<template>
  <div class="advertisement-large" v-show="advertisement.id">
    <div class="pxindBox">
      <img @click="jumpCourseDetail" :src="advertisement.images" alt="" />
    </div>
  </div>
</template>
<script>
import { setBaseUrl, gioPlatform, gioJumpType,handleJumpType } from '@/utils/tools';
const pageYear = (window.location.pathname.indexOf('ark/home') !== -1) ? 24 : 23;

export default {
  props: {
    advertisement: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lastTime: null,
      gioType: 1, // 用于埋点 1 点击 2曝光
    };
  },
  components: {},

  created() {},

  mounted() {},
  watch: {
    advertisement() {
      this.gioEvent(this.advertisement, (this.gioType = 2));
    },
  },
  methods: {
    // 请求弹窗数据
    jumpCourseDetail() {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(this.advertisement, (this.gioType = 1));
      this.lastTime = Date.now();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.advertisement);
    },
    gioEvent(item, type) {
      const { title, skipType } = item;
      const adId = item.id;
      if (type === 1) {
        // 点击广告
        // eslint-disable-next-line
        gio('evar.set', 'capsuleFigure_evar', title);
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: `${pageYear}考研-首页-胶囊区长图`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: `${pageYear}考研-首页-胶囊区长图`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId ? adId.toString() : null, // 广告ID
          adName_var: title || null, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType) || null, // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pxindBox {
    width: 670px;
    height: 130px;
    margin: 10px auto 0;
    text-align: center;
  // padding: 16px 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
